<script lang="ts">
  import { tStore } from '../../../i18n'

  let { visible }: { visible: boolean } = $props()
</script>

{#if visible}
  <div
    class="ai-spinner"
    role="status"
    aria-live="polite"
    aria-label={$tStore('views.dashboard.aiAnalysisInProgress')}
  >
    <div class="ai-spinner__ring" aria-hidden="true"></div>
    <span class="ai-spinner__label" aria-hidden="true">AI</span>
  </div>
{/if}

<style lang="scss">
  @use '../../../assets/styles/variables' as v;

  // Same general corner the AI-analysis toast used to occupy, offset a bit
  // higher so it doesn't sit directly under toasts that stack from the
  // Toaster's own bottom-right anchor.
  .ai-spinner {
    position: fixed;
    bottom: calc(#{v.$space-lg} + 3.5rem);
    right: v.$space-lg;
    width: 3.5rem;
    height: 3.5rem;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  // Sweeps from solid green down to transparent around the circle (a "comet
  // tail"), matching the gradient-ring reference from the ticket attachment —
  // not a hue cycle, an opacity fade.
  .ai-spinner__ring {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: conic-gradient(
      from 0deg,
      v.$color-success-fg 0deg,
      #16a34a 60deg,
      rgba(22, 163, 74, 0.08) 300deg,
      transparent 360deg
    );
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.18);
    animation: ai-spinner-spin 1.1s linear infinite;

    // Punch out the center so only a ring is visible — the label sits in the
    // hole, sized to match (2.5rem) so it doesn't clip the ring's inner edge.
    -webkit-mask: radial-gradient(
      farthest-side,
      transparent calc(100% - 8px),
      #000 calc(100% - 8px)
    );
    mask: radial-gradient(farthest-side, transparent calc(100% - 8px), #000 calc(100% - 8px));
  }

  .ai-spinner__label {
    position: relative;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: v.$color-surface-elevated;
    color: v.$color-success-fg;
    font-size: 0.8125rem;
    font-weight: 700;
    letter-spacing: 0.02em;
  }

  @keyframes ai-spinner-spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
